<div class="subscription-container">
    <div class="header">
        <h1>Advertisements</h1>
        <p>Manage your Premium Sponsored Advertisement to attract more clients.</p>
    </div>

    <!-- Loading Spinner -->
    <div class="loading-spinner" *ngIf="loading">
        <span class="material-symbols-outlined spin">refresh</span>
    </div>

    <div class="plans-wrapper" *ngIf="!loading">
        <div class="advertisement-section">
            <div class="section-header">
                <h2>Premium Sponsored Advertisement</h2>
                <p>Feature a special offer or promotional banner on your service pages to drive more bookings.</p>
            </div>

            <div class="ad-config-card" [class.locked]="currentTier !== 'PREMIUM'">
                
                <div class="lock-overlay" *ngIf="currentTier !== 'PREMIUM'">
                    <span class="material-symbols-outlined">lock</span>
                    <h3>Premium Feature</h3>
                    <p>Upgrade to the Premium Plan to unlock sponsored advertisements and attract more clients with custom promotional banners.</p>
                    <button class="btn-upgrade" routerLink="/merchant/subscription">Upgrade to Premium</button>
                </div>

                <div class="quota-info" *ngIf="currentTier === 'PREMIUM'">
                    <div class="quota-badge">
                        Available Activations: <strong>{{ remainingCredits }}/7</strong> this month
                    </div>
                    <div class="quota-notice" *ngIf="adData.isActive">
                        Your ad is currently running! It will automatically expire in <strong>{{ hoursLeft }} hours</strong>.
                    </div>
                    <div class="quota-notice warning" *ngIf="remainingCredits === 0 && !adData.isActive">
                        You have used all 7 activations for this month. Your quota will reset next month.
                    </div>
                </div>

                <div class="form-group toggle-group" *ngIf="currentTier === 'PREMIUM'">
                    <label>Enable Advertisement</label>
                    <label class="switch">
                        <input type="checkbox" [(ngModel)]="adData.isActive" [disabled]="remainingCredits === 0 && !adData.isActive">
                        <span class="slider round"></span>
                    </label>
                </div>

                <form (ngSubmit)="saveAdvertisement()">
                    <div class="form-group">
                        <label>Banner Title</label>
                        <input type="text" [(ngModel)]="adData.title" name="title" placeholder="e.g. Monsoon Wedding Special!" [disabled]="currentTier !== 'PREMIUM'" required>
                    </div>

                    <div class="form-group">
                        <label>Offer Text</label>
                        <textarea [(ngModel)]="adData.text" name="text" placeholder="e.g. Get 20% off on all bridal makeup packages if you book before August." [disabled]="currentTier !== 'PREMIUM'" required></textarea>
                    </div>

                    <div class="form-group">
                        <label>Offer / Promo Code (Optional)</label>
                        <input type="text" [(ngModel)]="adData.code" name="code" placeholder="e.g. BRIDE20" [disabled]="currentTier !== 'PREMIUM'" class="promo-input">
                    </div>

                    <button type="submit" class="btn-save-ad" [disabled]="currentTier !== 'PREMIUM' || savingAd">
                        {{ savingAd ? 'Saving...' : 'Save Advertisement' }}
                    </button>
                </form>

            </div>
        </div>
    </div>
</div>
